/* eslint-disable @typescript-eslint/no-misused-promises */
import { Crud, HttpClient, httpClient, RequestOptions } from 'lib/HttpClient';
import { Notification } from './models/Notification';

const REQUEST_TIMEOUT = 1200;

class NotificationApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'notifications', { 'x-api-version': 4 });
    }
    send(userId: string, options: RequestOptions) {
        return this.httpClient.post(`${this.api}/users/${userId}/notifications`, {
            ...options,
            headers: { 'x-api-version': 4 }
        });
    }
    async pollNotification<IDType extends string>({
        notification
    }: {
        notification: Notification<IDType>;
    }): Promise<Notification<IDType>> {
        return new Promise((resolve, reject) => {
            setTimeout(async () => {
                const result = await this.get(notification._id);
                if (!result || !result.ok) {
                    reject(new Error('Could not get Notification'));
                }

                if (result.body && result.body.status === 'PENDING') {
                    resolve(this.pollNotification({ notification: result.body }));
                }

                resolve(result.body);
            }, REQUEST_TIMEOUT);
        });
    }
    async getNotificationReceipts(id: string, options: RequestOptions) {
        const headers = options && options.headers ? { ...this.headers, ...options.headers } : this.headers;
        return this.httpClient.get(`${this.api}/notifications/${id}/receipts`, {
            ...options,
            headers
        });
    }

    async getAggregatedMetrics(options: RequestOptions) {
        const headers = options && options.headers ? { ...this.headers, ...options.headers } : this.headers;
        return this.httpClient.get(`${this.api}/notifications/metrics`, {
            ...options,
            headers
        });
    }

    async getAggregatedReceipts(options: RequestOptions) {
        const headers = options && options.headers ? { ...this.headers, ...options.headers } : this.headers;
        return this.httpClient.get(`${this.api}/notifications/receipts`, {
            ...options,
            headers
        });
    }
}

export const notificationApi = new NotificationApi(httpClient);
